export const opinions = [
  {
    id: "op-01",
    side: "正方",
    name: "老街口的猫",
    role: "前媒体从业者",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20thoughtful%20young%20woman%20in%20warm%20amber%20light%20against%20a%20plain%20cream%20background%2C%20soft%20shadows%2C%20minimal%20clean%20portrait%20photography%2C%20high%20detail%2C%20no%20text&width=200&height=200&seq=hlkd-av-01&orientation=squarish",
    quote:
      "证据链没闭合之前，任何笃定都只是情绪。我更关心那 17 分钟的空白，而不是谁嗓门大。",
    likes: 1284,
  },
  {
    id: "op-02",
    side: "反方",
    name: "半糖不加班",
    role: "品牌公关顾问",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20calm%20middle%20aged%20man%20in%20warm%20amber%20light%20against%20a%20plain%20charcoal%20background%2C%20soft%20shadows%2C%20minimal%20clean%20portrait%20photography%2C%20high%20detail%2C%20no%20text&width=200&height=200&seq=hlkd-av-02&orientation=squarish",
    quote:
      "从公关角度看，最初的回应并没有错，问题在于他们低估了网友拼接信息的速度。",
    likes: 987,
  },
  {
    id: "op-03",
    side: "正方",
    name: "考据癖阿泽",
    role: "独立研究员",
    avatar:
      "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20expressive%20young%20man%20in%20warm%20amber%20light%20against%20a%20plain%20beige%20background%2C%20soft%20shadows%2C%20minimal%20clean%20portrait%20photography%2C%20high%20detail%2C%20no%20text&width=200&height=200&seq=hlkd-av-03&orientation=squarish",
    quote:
      "把每一句话的出处标出来之后你会发现，真正自相矛盾的地方比想象中少，也更有意思。",
    likes: 1502,
  },
];